import React from "react";
import { Route, Routes } from "react-router-dom";
import AuthLayout from "../components/layouts/auth-layout";
import Login from "../containers/auth/login";

const AuthRoutes = () => {
  return (
    <AuthLayout>
      <Routes>
        <Route path="/login" Component={Login} />
      </Routes>
    </AuthLayout>
  );
};

export default AuthRoutes;
